
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Stratégie d’entreprise : pourquoi ma boîte ne décolle-t-elle pas ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment un blog d’entreprise peut booster votre stratégie et attirer des clients. Guide pratique pour créer un blog efficace et générateur de croissance.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Stratégie d’entreprise : pourquoi ma boîte ne décolle-t-elle pas ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous présente les bénéfices d’un blog d’entreprise et vous explique comment créer le vôtre.",
        },
      ],
    };
  },
};
